import { checkPermission } from '@/router/guards.ts'

const AttendantReviewModule = () => import('./AttendantReviewModule.vue')
const AttendantReviewIndex = () => import('./views/AttendantReviewIndex.vue')

export const attendantReviewRoute = {
  path: '/staff-reviews',
  name: 'attendant-review',
  component: AttendantReviewModule,
  meta: {
    title: 'Attendant Reviews',
    requiresAuth: true,
    keepAlive: true,
  },
  children: [
    {
      path: '',
      name: 'staff-reviews-index',
      component: AttendantReviewIndex,
      meta: {
        permission: 'attendant_review.view',
      },
      beforeEnter: checkPermission('attendant_review.view'),
    },
  ],
}
